export default __webpack_public_path__ + "static/checkin-logo-27c823641fe4348890cd5b516c0d4d9d.svg";